import React, { FunctionComponent, createContext, useContext } from 'react';

type ResourceProviderProps = {
  refName: string | null;
};

export type ResourceProviderType = ResourceProviderProps;

const ResourceProviderContext = createContext<ResourceProviderType>({
  refName: null,
});
ResourceProviderContext.displayName = 'Resource';

export function useResource() {
  return useContext(ResourceProviderContext);
}

const ResourceProvider: FunctionComponent<React.PropsWithChildren<ResourceProviderProps>> = ({
  refName,
  children,
}) => {
  return (
    <ResourceProviderContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        refName,
      }}>
      {children}
    </ResourceProviderContext.Provider>
  );
};

export default ResourceProvider;
